export const LIVE_CHAT_CONVERSATIONS_CALL = 'LIVE_CHAT_CONVERSATIONS_CALL';
export const LIVE_CHAT_CREATE_CONVERSATION_CALL = 'LIVE_CHAT_CREATE_CONVERSATION_CALL';
export const LIVE_CHAT_MESSAGES_CALL = 'LIVE_CHAT_MESSAGES_CALL';
export const LIVE_CHAT_SEND_MESSAGE_CALL = 'LIVE_CHAT_SEND_MESSAGE_CALL';
export const LIVE_CHAT_UPDATE_STATUS_CALL = 'LIVE_CHAT_UPDATE_STATUS_CALL';

export function callLiveChatConversations(status) {
    return { type: LIVE_CHAT_CONVERSATIONS_CALL, payload: { status } };
}

export function callCreateLiveChatConversation() {
    return { type: LIVE_CHAT_CREATE_CONVERSATION_CALL };
}

export function callLiveChatMessages(conversationId, limit, offset) {
    return { type: LIVE_CHAT_MESSAGES_CALL, payload: { conversationId, limit, offset } };
}

export function callSendLiveChatMessage(conversationId, body, attachments) {
    return { type: LIVE_CHAT_SEND_MESSAGE_CALL, payload: { conversationId, body, attachments } };
}

export function callUpdateLiveChatStatus(conversationId, status) {
    return { type: LIVE_CHAT_UPDATE_STATUS_CALL, payload: { conversationId, status } };
}
